import { useQuery } from "@tanstack/react-query";

import { apiClient } from "../api/client";
import { ServiceAdditionalInfoResponse } from "../api/PartnerPortalGatewayApi";

interface UseServiceAdditionalInfoResult {
  data: ServiceAdditionalInfoResponse | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useServiceAdditionalInfo = (serviceId: number | null): UseServiceAdditionalInfoResult => {
  const {
    data: queryData,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["serviceAdditionalInfo", serviceId],
    queryFn: async (): Promise<ServiceAdditionalInfoResponse> => {
      if (!serviceId) {
        throw new Error("Service ID is required");
      }

      return await apiClient.service.getServiceAdditionalInfo(serviceId);
    },
    enabled: !!serviceId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    data: queryData ?? null,
    isLoading,
    error: error?.message ?? null,
    refetch,
  };
};
